import { MEAL_CARD_ISSUERS, SHOW_MEAL_CARD_MODAL, HIDE_MEAL_CARD_MODAL } from './types';

export function showMealCardModal() {
  return {
    type: SHOW_MEAL_CARD_MODAL,
  };
}

export function getMealCardIssuers() {
  return (dispatch, getState) => {
    const { country } = getState().request;
    dispatch(showMealCardModal());

    return dispatch({
      type: MEAL_CARD_ISSUERS,
      endpoint: `/orderapp/v2/meal_cards?country_code=${country.tld}`,
      options: {
        method: 'GET',
      },
    });
  };
}

export function closeMealCardModal() {
  return {
    type: HIDE_MEAL_CARD_MODAL,
  };
}
